export function validarEmail(email) {
  if (email.includes("@") && email.includes(".")) return true;
  return false;
}
export function validarSenha(senha) {
  if (senha.length >= 6 && /[a-zA-Z]/.test(senha) && /\d/.test(senha))
    return true;
  return false;
}
